export interface NotificationDto {
  notificationId: number;
  deliveryId: number;
  userId: number;
  notificationTypeId: number;
  notificationTypeCode: string;
  notificationTypeCategory: string;
  title: string;
  body: string;
  redirectUri: string;
  read: boolean;
  createdAt: string;
}

export interface ActivityNotificationBody {
  activitySubject: string;
  activityType: string;
  activityUrl: string;
  dateTime: string;
  alertDate: string;
  userName: string;
  sourceEntityId: string;
}

export interface ReportingNotificationBody {
  reportName: string;
  reportType: string;
  reportStatus: string;
  reportUrl: string;
  fileSize: string;
  generatedDate: string;
  expirationDate: string;
  errorMessage?: string;
  sourceEntityId: string;
}

export function parseNotificationBody<T>(body: string): T | null {
  try {
    return JSON.parse(body) as T;
  } catch {
    return null;
  }
}

export interface NotificationByTypeDto {
  notificationTypeId: number;
  notificationTypeCode: string;
  notificationTypeCategory: string;
  notifications: NotificationDto[];
  totalCount: number;
  unreadCount: number;
}

export interface NotificationCategoryDto {
  category: string;
  notificationsByType: NotificationByTypeDto[];
  totalCount: number;
  unreadCount: number;
}

export interface GroupedNotificationsResponse {
  groupedByCategory: NotificationCategoryDto[];
  totalCount: number;
  unreadCount: number;
}

export interface NotificationTypeOverride {
  notificationTypeId: number;
  withinDays: number;
  limitPerType: number;
}

export interface NotificationCountResponse {
  totalCount: number;
  readCount: number;
  unreadCount: number;
}

export interface NotificationsByTypeResponse {
  notifications: NotificationDto[];
  totalCount: number;
  unreadCount: number;
}

export interface GroupedNotificationsRequest {
  defaultWithinDays: number;
  defaultLimitPerType: number;
  notificationTypeOverrides?: Record<string, NotificationTypeOverride>;
}
